var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"active-text-color":"#409eff","default-openeds":_vm.openedMenus,"default-active":_vm.$route.name,"router":true},on:{"open":_vm.open,"close":_vm.close}},[_c('submenu',{attrs:{"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }